import React, { useState } from "react";
import "./HeaderIncomeAndExpenses.css";
import axios from "axios";
import Swal from "sweetalert2";

const HeaderIncomeAndExpense = ({ data, reloadChildData }) => {
  const userId = data && data.id ? data.id : null;
  const [objincomeAndExpenses, setObjIncomeAndExpenses] = useState({
    incomeAndExpenses: "",
    createAt: "",
    description: "",
    amount: "",
    userId: userId,
  });

  const handlerCreate = async (e) => {
    e.preventDefault();
    const endpoint = `${process.env.REACT_APP_LEALTAD_INCOME_AND_EXPENSES}`;
    const isIncome = objincomeAndExpenses.incomeAndExpenses === "Ingresos";
    try {
      const res = await axios.post(endpoint, {
        objincomeAndExpenses,
      });
      const successMessage = isIncome
        ? "Se creó el ingreso con éxito"
        : "Se creó el egreso con éxito";

      Swal.fire({
        icon: "success",
        title: "Exito",
        text: successMessage || res.data.message,
      });
      reloadChildData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de llenar el Formulario",
      });
    }
  };

  return (
    <>
      {userId ? (
        <div className="all_newig_eg-lealtad" id="income">
          <div className="box_all_ing_eg-lealtad">
            <h2 className="tittle_ig_eg-lealtad">Crear Pagos y Cobros</h2>
            <div className="display_selec_date-lealtad">
              <select
                className="select_ig_eg-lealtad"
                onChange={(e) =>
                  setObjIncomeAndExpenses({
                    ...objincomeAndExpenses,
                    incomeAndExpenses: e.target.value,
                  })
                }
                value={objincomeAndExpenses.incomeAndExpenses}
              >
                <option>Seleciona un valor</option>
                <option value="Ingresos">Ingresos</option>
                <option value="Egresos">Egresos</option>
              </select>
              <input
                className="select_ig_eg-lealtad"
                type="date"
                value={objincomeAndExpenses.createAt || ""}
                onChange={(e) =>
                  setObjIncomeAndExpenses({
                    ...objincomeAndExpenses,
                    createAt: e.target.value,
                  })
                }
              />
              <input
                className="select_ig_eg-lealtad"
                type="number"
                placeholder="Monto"
                value={objincomeAndExpenses.amount || ""}
                onChange={(e) =>
                  setObjIncomeAndExpenses({
                    ...objincomeAndExpenses,
                    amount: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <textarea
                className="text_area_ig_eg-lealtad"
                placeholder="Ingrese una Descripcion del archivo"
                value={objincomeAndExpenses.description || ""}
                onChange={(e) =>
                  setObjIncomeAndExpenses({
                    ...objincomeAndExpenses,
                    description: e.target.value,
                  })
                }
              ></textarea>
            </div>
            <div className="box_button_ig_eg-lealtad">
              <button
                className="button_ig_eg-lealtad"
                type="button"
                onClick={(e) => handlerCreate(e)}
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default HeaderIncomeAndExpense;
